export const GET_CONFIGURATION_ASYNC = 'GET_CONFIGURATION_ASYNC'
export const SET_SELECTED_APPLICATION = 'SET_SELECTED_APPLICATION'
